"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEditableDesignAssetLayer = exports.editableDesignAssetLayerRuleSet = exports.isEditableDesignAssetLayerData = exports.editableDesignAssetLayerUserDataRuleSet = exports.isRegion = exports.regionRuleSet = exports.isRegionDefaultData = exports.regionDefaultDataRuleSet = void 0;
const Layer_1 = require("./Layer");
const typeguard_1 = require("../../types/typeguard");
exports.regionDefaultDataRuleSet = {
  fill: typeguard_1.isNonEmptyString
};
const isRegionDefaultData = value => (0, typeguard_1.isType)(value, exports.regionDefaultDataRuleSet);
exports.isRegionDefaultData = isRegionDefaultData;
exports.regionRuleSet = {
  className: typeguard_1.isNonEmptyString,
  name: typeguard_1.isNonEmptyString,
  defaultData: exports.isRegionDefaultData
};
const isRegion = value => (0, typeguard_1.isType)(value, exports.regionRuleSet);
exports.isRegion = isRegion;
exports.editableDesignAssetLayerUserDataRuleSet = {
  fill: typeguard_1.isNonEmptyString
};
const isEditableDesignAssetLayerData = value => (0, typeguard_1.isType)(value, exports.editableDesignAssetLayerUserDataRuleSet);
exports.isEditableDesignAssetLayerData = isEditableDesignAssetLayerData;
exports.editableDesignAssetLayerRuleSet = {
  type: value => value === 'editable_design_asset',
  image: typeguard_1.isNonEmptyString,
  svg: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  regions: value => Array.isArray(value) && value.every(exports.isRegion),
  colorBlockColorSchemes: value => Array.isArray(value) && value.every(typeguard_1.isNonEmptyString),
  userData: (0, typeguard_1.optional)(exports.isEditableDesignAssetLayerData)
};
const isEditableDesignAssetLayer = value => (0, Layer_1.isLayer)(value) && (0, typeguard_1.isType)(value, exports.editableDesignAssetLayerRuleSet);
exports.isEditableDesignAssetLayer = isEditableDesignAssetLayer;